module.exports = __webpack_public_path__ + "img/cloud05.dda4b81b.png";